var _mask, _mask2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 27,
    viewBox: "0 0 50 30",
    fill: "none",
    "aria-label": "bytt bil",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -10,
    width: 60,
    height: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.805615,
    cy: 21.276339,
    r: 17,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.190098,22.527278 4.161018,2.014095 -3.270733,-10.515119 -9.903926,4.16024 4.20303,2.00898 c -1.515719,3.480102 -4.557484,6.325208 -9.837592,9.145001 l 2.834455,4.683612 c 4.809634,-2.324809 9.261579,-6.030892 11.813748,-11.496809 z",
    stroke: "#000",
    strokeWidth: 5
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -10,
    width: 60,
    height: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.4471504,7.9687034 0.28613268,5.9546079 3.5568654,16.469727 13.460792,12.309486 9.2577617,10.300507 C 10.773481,6.8204055 13.815246,3.9752986 19.095354,1.1555057 L 16.260899,-3.5281057 C 11.451265,-1.2032967 6.9993197,2.502786 4.4471504,7.9687034 Z",
    stroke: "#000",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 25.828913,5.761505 H 45.259836 L 43.177913,-0.48417692 H 27.910799 Z m 17.349,6.939537 c 1.110351,0 2.081923,-0.971572 2.081923,-2.081799 0,-1.110351 -0.971572,-2.081924 -2.081923,-2.081924 -1.11035,0 -2.081922,0.832794 -2.081922,2.081924 0,1.249129 0.832793,2.081799 2.081922,2.081799 z m -15.267114,0 c 1.249141,0 2.081935,-0.971572 2.081935,-2.081799 0,-1.110351 -0.832794,-2.081924 -2.081935,-2.081924 -1.249129,0 -2.081886,0.832794 -2.081886,2.081924 0,1.249129 0.971548,2.081799 2.081886,2.081799 z m 17.21026,-13.879185 2.914593,8.327555 v 11.103383 c 0,0.832669 -0.555114,1.387907 -1.387909,1.387907 h -1.387907 c -0.832794,0 -1.387906,-0.555238 -1.387906,-1.387907 V 16.864888 H 27.216833 v 1.387907 c 0,0.832669 -0.555163,1.387907 -1.38792,1.387907 h -1.387919 c -0.832757,0 -1.38792,-0.555238 -1.38792,-1.387907 V 7.149412 l 2.91463,-8.327555 c 0.277594,-0.832756 1.110338,-1.387919 2.081885,-1.387919 h 15.267103 c 0.694015,0 1.665589,0.555163 1.804367,1.387919 z",
    className: "svgMain",
    fill: "#016cc5",
    mask: "url(#mask1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.0901668,18.361747 H 24.52109 L 22.439167,12.116065 H 7.1720521 Z m 17.3490002,6.939536 c 1.110351,0 2.081923,-0.971573 2.081923,-2.081799 0,-1.11035 -0.971572,-2.081923 -2.081923,-2.081923 -1.11035,0 -2.081923,0.832794 -2.081923,2.081923 0,1.249129 0.832794,2.081799 2.081923,2.081799 z m -15.2671149,0 c 1.2491414,0 2.0819356,-0.971573 2.0819356,-2.081799 0,-1.11035 -0.8327942,-2.081923 -2.0819356,-2.081923 -1.2491286,0 -2.0818853,0.832794 -2.0818853,2.081923 0,1.249129 0.9715475,2.081799 2.0818853,2.081799 z m 17.2102599,-13.879184 2.914593,8.327555 v 11.103382 c 0,0.832669 -0.555113,1.387907 -1.387908,1.387907 H 24.52109 c -0.832794,0 -1.387907,-0.555238 -1.387907,-1.387907 V 29.465129 H 6.4780864 v 1.387907 c 0,0.832669 -0.5551629,1.387907 -1.3879196,1.387907 H 3.7022472 c -0.8327568,0 -1.3879196,-0.555238 -1.3879196,-1.387907 V 19.749654 L 5.2289575,11.422099 C 5.5065514,10.589343 6.3392957,10.03418 7.3108428,10.03418 H 22.577945 c 0.694016,0 1.665589,0.555163 1.804367,1.387919 z",
    fill: "#016cc5",
    className: "svgMain",
    mask: "url(#mask2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.4471504,7.9687034 0.28613268,5.9546079 3.5568654,16.469727 13.460792,12.309486 9.2577617,10.300507 C 10.773481,6.8204055 13.815246,3.9752986 19.095354,1.1555057 L 16.260899,-3.5281057 C 11.451265,-1.2032967 6.9993197,2.502786 4.4471504,7.9687034 Z",
    fill: "#016cc5",
    className: "svgMain"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 45.190098,22.527278 4.161018,2.014095 -3.270733,-10.515119 -9.903926,4.16024 4.20303,2.00898 c -1.515719,3.480102 -4.557484,6.325208 -9.837592,9.145001 l 2.834455,4.683612 c 4.809634,-2.324809 9.261579,-6.030892 11.813748,-11.496809 z",
    fill: "#016cc5",
    className: "svgMain"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapCar);
export default __webpack_public_path__ + "static/media/swap_car.182555d3.svg";
export { ForwardRef as ReactComponent };